module.exports = __webpack_public_path__ + "img/hand.1e440c6f.png";